module.exports = __webpack_public_path__ + "img/plant_2.4b32ff16.webp";